/**
 * CRITICAL: Used in <head> script (Critical Rendering Path).
 * Keep this file dependency-free and tiny!
 * Adding imports or heavy logic here will trigger Webpack to create
 * a blocking 'defaultVendors' chunk and slow down the app startup.
 */
export const preferredThemeModeLocalStorageKey = 'ui-preferred-theme-mode';
